import { usePermissionsStore } from '../store/permissionsStore';
import type { ModuleAccess } from '../store/permissionsStore';

export type { ModuleAccess };

export function usePermission(moduleId: string): ModuleAccess & { level: string } {
  const getModuleAccess = usePermissionsStore(s => s.getModuleAccess);
  const access = getModuleAccess(moduleId);
  return {
    ...access,
    level: access.canAdmin ? 'admin' : access.canEdit ? 'editor' : access.canView ? 'viewer' : 'none',
  };
}
